import script from "./OfflineStore.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineStore.vue?vue&type=script&setup=true&lang=js"

import "./OfflineStore.vue?vue&type=style&index=0&id=487234d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487234d7"]])

export default __exports__